/*
 *   File : manage-goal.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../Components/Cta";
import { BasketCard } from "../../Components/Card";
import { useNavigate } from "react-router-dom";
import { APIService } from "../../Service";
import { CustomTab, EmptyScreen, Loader } from "../../Components/Other";
import MapGoalsToTenure from "./Helper/map-goals-tenure";

const TAB_DATA = [
  { id: 1, label: "Created goals", name: "Created goals" },
  {
    id: 2,
    label: "Mapped goals against tenure & returns ",
    name: "Mapped goals against tenure & returns ",
  },
];

export default function ManageGoal() {
  const navigate = useNavigate();
  const [goals, setGoals] = useState([]);
  const [emptyScreen, setEmptyScreen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [tab, setTab] = useState(TAB_DATA[0].id);
  useEffect(() => {
    setLoader(true);
    _getGoals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const _getGoals = () => {
    const is_post = false;
    APIService(is_post, "goal/list")
      .then((response) => {
        if (response.status_code === 200) {
          // console.log(response.data);
          setGoals(response.data);
        } else {
          setEmptyScreen(true);
          console.error(response);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.error(err);
        setLoader(false);
      });
  };
  const _handleTabChange = (id) => {
    setTab(id);
  };
  return (
    <div className="row px-3">
      <div className="col-12 e-pt-20px">
        <div className="row">
          <div className="col-lg-10 col-12">
            <div className="e-customer-tab d-flex flex-nowrap column-gap-2 justify-content-md-start justify-content-between e-border-1px-bottom-magnolia-light e-pt-36px">
              {TAB_DATA.map((data, index) => (
                <CustomTab
                  key={index}
                  type={1}
                  borderRadius="border-radius-4"
                  tabData={data}
                  tabIndex={tab}
                  background="bg-white"
                  handleChange={() => _handleTabChange(data.id)}
                />
              ))}
            </div>
          </div>

          <div className="col-lg-2 col-12 d-flex justify-content-end align-items-end">
            <PrimaryButton
              ClassName="e-border-radius-pill e-font-weight-500 py-2 e-font-16 e-bg-blue-violet text-white e-primary-font-poppins"
              name="Add Goal"
              onPress={() => navigate("/manage-goal/add")}
            />
          </div>
        </div>
      </div>
      <div className="col-12">
        {loader ? (
          <div className="d-flex min-vh-100 align-items-center justify-content-center">
            <Loader width={30} />
          </div>
        ) : emptyScreen ? (
          <EmptyScreen message="Data Not Found" width="200px" />
        ) : (
          <div className="row">
            {tab === 1 ? (
              <div className="col-12">
                <div className="row row-cols-xl-3 row-cols-md-2 row-cols-1 e-pt-20px row-gap-3">
                  {goals.map((goal) => (
                    <div className="col" key={goal.goal_style_id}>
                      <BasketCard
                        title={goal.name}
                        type={2}
                        img={goal.image}
                        content={goal.description}
                        // returns={12.96}
                        bgColor="e-bg-magnolia-dark"
                        borderColor="e-border-1px-languid-lavender"
                        badges={goal.tag}
                        recommended={goal.recommended}
                        handleView={() =>
                          navigate(`/manage-goal/edit/${goal.goal_style_id}`)
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="col-12">
                <MapGoalsToTenure />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
